import styled from 'styled-components';
import { asRem } from 'utils';
import { Section } from 'Container';
import { breakpoints } from 'Theme';

export const VideoSectionStyle = styled(Section)`
  text-align: center;
  @media (min-width: ${breakpoints.md}) {
    text-align: left;
  }

  .content-wrapper {
    margin-horizontal: ${asRem(24)};
  }

  .image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: ${asRem(32)};

    @media (min-width: ${breakpoints.md}) {
      justify-content: flex-end;
    }

    @media (min-width: ${breakpoints.lg}) {
      justify-content: center;
    }
  }

  .video-image {
    width: ${asRem(330)};
    height: auto;

    @media (min-width: ${breakpoints.md}) {
      width: ${asRem(380)};
    }

    @media (min-width: ${breakpoints.lg}) {
      width: ${asRem(430)};
    }
  }
`;
